import { render, staticRenderFns } from "./CalldataDecoderPanel.vue?vue&type=template&id=3b1ecf0c&scoped=true"
import script from "./CalldataDecoderPanel.vue?vue&type=script&lang=ts"
export * from "./CalldataDecoderPanel.vue?vue&type=script&lang=ts"
import style0 from "./CalldataDecoderPanel.vue?vue&type=style&index=0&id=3b1ecf0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1ecf0c",
  null
  
)

export default component.exports